// hooks/travelPlan/context.js

import { createContext, useContext, useReducer, useMemo } from 'react';
import { travelPlansReducer, initialState } from './reducer';

const TravelPlansContext = createContext();

export const TravelPlansProvider = ({ children }) => {
    const [state, dispatch] = useReducer(travelPlansReducer, initialState);

    const value = useMemo(() => [state, dispatch], [state]);

    return <TravelPlansContext.Provider value={value}>{children}</TravelPlansContext.Provider>;
};

export const useTravelPlansContext = () => {
    const context = useContext(TravelPlansContext);
    if (!context) {
        throw new Error('useTravelPlansContext must be used within TravelPlansProvider');
    }
    return context;
};
